import { privacyPolicy, termOfService } from '@/lib/links';
import { Box, CardSection } from '@mantine/core';
import Link from 'next/link';

interface Props {
    bg: string;
}

const ConsentDisclaimer = ({ bg }: Props) => {
    return (
        <CardSection bg={bg} className="py-4">
            <Box className="mx-auto max-w-[331px] pb-2 text-center text-[11px] font-medium leading-4 -tracking-[0.02em] text-slate-600">
                By clicking the button above you agree to our
                <Box>
                    <Link
                        target="_blank"
                        href={termOfService}
                        className="text-[#ED614A] underline"
                        rel="noopener noreferrer"
                    >
                        Terms of service
                    </Link>{' '}
                    and {''}
                    <Link
                        target="_blank"
                        href={privacyPolicy}
                        className="text-[#ED614A] underline"
                        rel="noopener noreferrer"
                    >
                        Privacy policy
                    </Link>
                </Box>
            </Box>
        </CardSection>
    );
};

export default ConsentDisclaimer;
